import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';

interface IStyleProps {
  $showGreenBorder: boolean;
  $showError?: boolean;
  $disabled?: boolean;
}

const getBorderColor = (props: IStyleProps) => {
  if (props.$disabled) return COLORS.GREY_32;

  if (props.$showError) return COLORS.RED_8;

  if (props.$showGreenBorder) return COLORS.GREEN_8;

  return COLORS.GREY_32;
};

const getFocusColor = (props: IStyleProps) => {
  if (props.$showError) return COLORS.RED_8;

  if (props.$showGreenBorder) return COLORS.GREEN_8;

  return COLORS.BLUE_11;
};

export const StyledInputWrapper = styled.div<IStyleProps>`
  .input-group {
    border: 1px solid ${(props) => getBorderColor(props)} !important;

    &:focus-within {
      box-shadow: 0px 0px 4px 1px ${(props) => getFocusColor(props)} !important;
      border: 1px solid ${(props) => getFocusColor(props)} !important;
    }
  }
`;
